<div class="o-grid">
	<div class="o-grid__cell">
		<div class="c-card c-panels">
			<ng-container *ngFor="let item of vm.items ; let $index=index">
				<a *ngIf="item.onClick" class="c-panel c-panel--link" id="profileMenuItem{{$index}}" [attr.data-testid]="item.testId ? 'profile-' + item.testId : null" (click)="item.href==='#' && item.onClick && item.onClick($event)">{{ item.label }}</a>
				<a *ngIf="!item.onClick" class="c-panel c-panel--link" id="profileMenuItem{{$index}}" [attr.data-testid]="item.testId ? 'profile-' + item.testId : null" [routerLink]="item.href">{{ item.label }}</a>
			</ng-container>
		</div>
	</div>
</div>
